

































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import moment from 'moment';
import utils from '@/utils/utils';
import { emptyRule } from '@/utils/rules';
import AMSDialog from '@/components/AMSDialog.vue';
import AMSProductImg from '@/components/AMSProductImg.vue';
import AMSTable from '@/components/AMSTable.vue';
import AMSOperateLogs from '@/components/AMSOperateLogs.vue';
import Ship from './ship.vue';
import { UserStore } from '@/store/modules/user';
import { logistics, cancelShip, getShipStatusName, shipBySf, shipCompany, cancel, ship, getShipCompanyName } from '@/api/shipment';
import { materialDetails, passMaterial, cancelMaterial, pendingAllocation, stockList, shippedList } from '@/api/materials';
@Component({
  components: {
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-dialog': AMSDialog,
    'ams-table': AMSTable,
    'ams-operate-logs': AMSOperateLogs,
    'ams-ship-record': Ship
  }
})
export default class materialsDetails extends Vue {
  shippedData: any = []; //发货清单
  stockData: any = []; //出库清单
  allocation: any = []; //配货清单
  valid: Boolean = true;
  BreadItem = [
    {
      text: '营销管理',
      disabled: false
    },
    {
      text: '物料申请',
      disabled: false,
      href: '/materials'
    },
    {
      text: '物料申请详情',
      disabled: true
    }
  ];
  materialId: string | (string | null)[] = '';
  materialsDetails: any = {};
  recordList = [];
  activeTab: any = null;
  modalDialog: Boolean = false;
  requestLoading: Boolean = false;
  modaltitle: String = '';
  modalType: String = '';
  modelWarning: String = '';
  modalRemark: String = '';
  isExternalShipper: Boolean = false;
  // 商品已关闭
  cancelproductHeaders = [
    {
      text: '序号',
      align: 'center',
      render: (h: any, param: any) => {
        return h('div', `${param.index + 1}  `);
      }
      // width:50
    },
    {
      text: '商品',
      render: (h: any, param: any) => {
        return h(AMSProductImg, {
          props: {
            product: param.row.product,
            pictureWidth: 40,
            pictureHeight: 40,
            isShowNumber: true
          }
        });
      },
      align: 'left'
    },
    {
      text: '容量',
      // align: 'right',
      render: (h: any, param: any) => {
        return h('div', `${param.row.product.capacity || ''}`);
      }
    },
    {
      text: '单价',
      value: 'price',
      align: 'right',
      sortable: false
    },
    {
      text: '数量',
      align: 'right',
      sortable: false,
      value: 'quantity',
      width: 200
    }
  ];
  // 商品信息(待审核状态的)header
  productHeaders = [
    {
      text: '序号',
      align: 'center',
      render: (h: any, param: any) => {
        return h('div', `${param.index + 1}  `);
      }
      // width:50
    },
    {
      text: '商品',
      render: (h: any, param: any) => {
        return h(AMSProductImg, {
          props: {
            product: param.row.product,
            pictureWidth: 40,
            pictureHeight: 40,
            isShowNumber: true
          }
        });
      },
      align: 'left'
    },
    {
      text: '容量',
      // align: 'right',
      render: (h: any, param: any) => {
        return h('div', `${param.row.product.capacity || ''}`);
      }
    },
    {
      text: '单价',
      value: 'price',
      align: 'right',
      sortable: false
    },
    {
      text: '数量',
      align: 'right',
      sortable: false,
      value: 'quantity',
      isInputNumber: {
        type: 'materialsQuantity'
      },
      width: 200
    }
  ];
  // 不是待审核状态的header
  noPendingConfirmproductHeaders = [
    {
      text: '序号',
      align: 'center',
      render: (h: any, param: any) => {
        return h('div', `${param.index + 1}  `);
      }
      // width:50
    },
    {
      text: '商品',
      render: (h: any, param: any) => {
        return h(AMSProductImg, {
          props: {
            product: param.row.product,
            pictureWidth: 40,
            pictureHeight: 40,
            isShowNumber: true
          }
        });
      },
      align: 'left'
    },
    {
      text: '容量',
      // align: 'right',
      render: (h: any, param: any) => {
        return h('div', `${param.row.product.capacity || ''}`);
      }
    },
    {
      text: '单价',
      value: 'price',
      align: 'right',
      sortable: false
    },
    {
      text: '数量',
      align: 'right',
      sortable: false,
      value: 'quantity',
      width: 200
    }
  ];
  // 操作信息header
  operateHeaders = [
    {
      text: '操作者',
      align: 'left',
      render: (h: any, param: any) => {
        return h('div', `${param.row.operator.name}  `);
      },
      width: 150
    },
    { text: '操作时间', align: 'left', value: 'creationTime', width: 200, isFormatDateTime: true },
    {
      text: '操作类型',
      align: 'left',
      width: 150,
      render: (h: any, param: any) => {
        return h('span', this.switchOrderOperateType(param.row.operateType)!.text);
      }
    },
    {
      text: '订单状态',
      align: 'left',
      width: 180,
      render: (h: any, param: any) => {
        return h(
          'span',
          {
            style: {
              color: this.switchStatus(param.row.newState)!.color
            }
          },
          `${param.row.oldState ? this.switchStatus(param.row.oldState)!.text : ''} ${param.row.oldState ? '->' : ''}${this.switchStatus(param.row.newState)!.text}`
        );
      }
    },
    {
      text: '备注',
      value: 'Remark',
      maxWidth: 80,
      Width: 80,
      type: 'html',
      render: (h: any, param: any) => {
        var text = `${param.row.remark ? param.row.remark : ''} <br/>${param.row.itemChanges}`;
        return h('div', {
          props: {},
          domProps: {
            innerHTML: text
          }
        });
      }
    }
  ];
  rules = {
    nameRules: [emptyRule('备注')]
  };
  created() {
    this.isExternalShipper = UserStore.isExternalShipper
    if( this.isExternalShipper){
      this.productHeaders.splice(3,1)
      this.noPendingConfirmproductHeaders.splice(3,1)
      this.cancelproductHeaders.splice(3,1)
    }
    this.materialId = this.$route.query.id;
    if (this.$route.query.tabActive == 'materialsShip') {
      this.activeTab = 'materialsShip';
    }
    this.getAllocation();
    this.getStockList();
    this.getShippedList();
    this.getMaterialsDetails();
  }
  // 申请详情
  getMaterialsDetails() {
    materialDetails(this.materialId).then((data: any) => {
      this.materialsDetails = data;
    });
  }
  // 配货清单
  getAllocation() {
    pendingAllocation(this.materialId).then((data: any) => {
      this.allocation = data.items;
      this.allocation = data.items.map((item: any) => {
        if (item.product) {
          item.id = item.product.id;
        }
        item.quantity = 0;
        return item;
      });
    });
  }
  //  已出库清单
  getStockList() {
    stockList(this.materialId).then((data: any) => {
      this.stockData = data.items;
      this.stockData.map((v: any) => {
        v.statusName = getShipStatusName(v.status);
        v.stockTime = v.stockTime ? utils.formatDateByFormat(v.stockTime, 'yyyy-MM-dd hh:mm:ss') : '';
        v.cancelStockTime = v.cancelStockTime ? utils.formatDateByFormat(v.cancelStockTime, 'yyyy-MM-dd hh:mm:ss') : '';
      });
    });
  }
  // 已发货清单
  getShippedList() {
    shippedList(this.materialId).then((data: any) => {
      this.shippedData = data.items;
      this.shippedData.map((v: any) => {
        v.statusName = getShipStatusName(v.status);
        v.stockTime = v.stockTime ? utils.formatDateByFormat(v.stockTime, 'yyyy-MM-dd hh:mm:ss') : '';
        v.cancelStockTime = v.cancelStockTime ? utils.formatDateByFormat(v.cancelStockTime, 'yyyy-MM-dd hh:mm:ss') : '';
        v.logisticsCompanyName = getShipCompanyName(v.logisticsCompany);
        v.shippedTime = v.shippedTime ? utils.formatDateByFormat(v.shippedTime, 'yyyy-MM-dd') : '';
      });
    });
  }

  formatPrice(num: number) {
    return utils.formatCurrencyPrice(num);
  }
  formatDateTime(date: string) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }
  // 获取配货/出库/发货
  refreshShipRecord() {
    this.getAllocation();
    this.getStockList();
    this.getShippedList();
  }
  //tabchange
  tabActived(value: string) {
    if (value === 'materialsShip') {
      this.refreshShipRecord();
    }
  }
  getPermission(name: string) {
    return utils.isPermission(name);
  }
  modalOpen(type: String) {
    this.modalType = type;
    this.modalDialog = true;
    this.modalRemark = '';
    (this.$refs.cancelDelForm as any).resetValidation();
    if (this.modalType === 'cancelApplay') {
      this.modaltitle = '取消申请单';
      if (this.materialsDetails.state === 'PartialDelivery') {
        //部分发货
        this.modelWarning = '商品已部分发货，确定取消未发货的商品？ 取消后，已出库的商品将取消出库并释放库存';
      } else if (this.materialsDetails.state === 'MaterialPartialGivenOut') {
        //部分发放
        this.modelWarning = '商品已部分领取，确定取消未领取的商品？ 取消后，已出库的商品将取消出库并释放库存';
      } else {
        this.modelWarning = '确定取消申请单吗？';
      }
    } else if (this.modalType === 'applayOk') {
      this.modaltitle = '审核申请单';
      this.modelWarning = '确定将该申请通过审核吗？';
    }
    //  else if (this.modalType === 'backModify') {
    //   this.modaltitle = '审核不通过，返回修改';
    //   this.modelWarning = '确定将该申请返回修改吗？';
    // }
  }
  modalCancel() {
    this.modalDialog = false;
    (this.$refs.cancelDelForm as any).resetValidation();
  }
  // 操作详情的操作type OrderOperateType
  switchOrderOperateType(status: string) {
    switch (status) {
      case 'SubmitMaterialOrder':
        return { color: '#FE5500', text: '提交申请单' };
      case 'CancelMaterialOrder':
        return { color: '#FE5500', text: '取消申请单' };
      case 'Submit':
        return { color: '#FE5500', text: '提交订单' };
      case 'ConfirmPrice':
        return { color: '#00A854', text: '确认订单价格' };
      case 'Approve':
        return { color: 'lightpink', text: '审核通过' };
      case 'BackToConfirm':
        return { color: 'lightpink', text: '返回确认' };
      case 'AllocationAndOutStock':
        return { color: '#00a679', text: '配货并出库' };
      case 'CancelOutStock':
        return { color: '#00a679', text: '取消出库' };
      case 'Ship':
        return { color: '#00a679', text: '确认发货' };
      case 'CancelShip':
        return { color: '#00a679', text: '取消发货' };
      case 'CancelOrder':
        return { color: '#00a679', text: '取消订单' };
      case 'Edit':
        return { color: '#00a679', text: '修改申请单' };
      case 'Receive':
        return { color: '#00a679', text: ' 领取发放单' };
      case 'CancelRecive':
        return { color: '#00a679', text: ' 取消发放' };
      case 'GiveOut':
        return { color: '#00a679', text: ' 发放' };
    }
  }
  modalSure() {
    if ((this.$refs.cancelDelForm as HTMLFormElement).validate()) {
      this.modalDialog = false;
      if (this.modalType === 'applayOk') {
        //审核通过
        this.applayOkConfirm();
      } else if (this.modalType === 'cancelApplay') {
        //取消申请
        this.cancelApplay();
      }
    }
  }
  //审核通过
  applayOkConfirm() {
    let orderList: any = [];
    this.materialsDetails.items.map((item: any) => {
      let temp: any = {};
      temp['productId'] = item.productId;
      temp['quantity'] = item.quantity !== '' ? item.quantity : 1;
      orderList.push(temp);
    });
    passMaterial({
      orderId: this.materialId,
      remark: this.modalRemark,
      items: orderList
    }).then(() => {
      this.modalDialog = false;
      this.getMaterialsDetails();
    });
  }
  //取消申请
  cancelApplay() {
    cancelMaterial({
      orderId: this.materialId,
      remark: this.modalRemark
    }).then(() => {
      this.modalDialog = false;
      this.getMaterialsDetails();
      this.refreshShipRecord();
    });
  }
  showTabActive() {
    if (this.materialsDetails.state !== 'Pending') {
      if (this.materialsDetails.state == 'Canceled') {
        if ((this.stockData && this.stockData.length > 0) || (this.shippedData.items && this.shippedData.items.length > 0)) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }
  }
  //返回修改
  backModify() {
    // request
    // .post(`/api/Order/${this.orderId}/Review`, {
    //   orderId: this.orderId,
    //   remark: this.confirmMemo,
    //   isPendingPass
    // })
    // .then(data => {
    //   this.confirmDialog = false;
    //   this.getMaterialsDetails();
    // });
  }
  sumArr(arr: any, itemName: string, itemName2: string) {
    if (arr) {
      var sum = 0;
      let Arr: any = [];
      arr.map((item: any) => {
        if (itemName2) {
          Arr.push(item[itemName] * item[itemName2]);
        } else {
          Arr.push(item[itemName]);
        }
      });
      var sum = 0;
      Arr.forEach(function(val: any) {
        sum += Number(val);
      });
      return sum;
    }
  }
  customerType(customerName: string) {
    switch (customerName) {
      case 'NewCustomer': /// 新客户
        return { color: '#FE5500', text: '新客户' };
      case 'OldCustomer': /// 旧客户
        return { color: '#FE5500', text: '老客户' };
      case 'None': /// 无
        return { color: '#FE5500', text: '无' };
    }
  }
  switchStatus(state: string) {
    switch (state) {
      case 'Pending': /// 待审核
        return { color: '#FE5500', text: '待审核' };
      case 'Order': /// 待发货
        return { color: 'red', text: '待发货' };
      case 'PartialDelivery': /// 部分发货
        return { color: 'red', text: '部分发货' };
      case 'Canceled': /// 已关闭
        return { color: '#999999', text: '已关闭' };
      case 'Finished': /// 已完成
        return { color: '#00A854', text: '已完成' };
      case 'MaterialPendingGiveOut': /// (物料单)待发放
        return { color: 'red', text: '待发放' };
      case 'MaterialPartialGivenOut': ///  (物料单)部分发放
        return { color: 'red', text: '部分发放' };
      case 'MaterialReceiving': ///  (物料单)待领取
        return { color: 'red', text: '待领取' };
    }
  }
}
